"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/TemplatesMoved/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _noticeBar = require('web/services/context/noticeBar');

 const TEMPLATES_MOVED_NOTICE = 'Templates moved: open them from the Templates button in any chat.'; exports.TEMPLATES_MOVED_NOTICE = TEMPLATES_MOVED_NOTICE
const SEEN_KEY = 'templatesMovedNoticeSeen'

// Shown once per browser; storage can be unavailable, and then it shows each time.
const takeFirstVisit = () => {
  try {
    if (window.localStorage.getItem(SEEN_KEY)) return false
    window.localStorage.setItem(SEEN_KEY, '1')
  } catch (e) { /* show it */ }
  return true
}

/* Settings → Templates moved into the chat's Templates dialog. Old links and
 * bookmarks land in the inbox, with a one-time notice saying where it went. */
const TemplatesMoved = () => {
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  _react.useEffect.call(void 0, () => {
    if (takeFirstVisit()) showSuccessBar(exports.TEMPLATES_MOVED_NOTICE)
  }, [showSuccessBar])
  return _react2.default.createElement(_reactrouterdom.Redirect, { to: _routes2.default.INBOX.ROOT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} )
}

exports. default = TemplatesMoved
